// declare global triple whale function
import useAddLine from '@framework/actual-cart/use-add-line'


import React, { useEffect, useState } from 'react'
import s from './AddToCartButton.module.css'
import { Button, useUI } from '@components/ui'
import { useTranslations } from 'next-intl'
import isEmpty from 'lodash.isempty'
import useUpdateDiscount from '@framework/actual-cart/use-update-discount'
import { useRouter } from 'next/router'
import {
  SelectedOptions,
  selectDefaultOptionFromProduct,
  getProductVariant
} from '@components/product/helpers'
import Cookies from 'js-cookie'

export interface AddToCartButtonProps {
  styleVariant?: 'secondaryMedium' | 'primaryXSmall' | 'primarySmall' | 'primaryMedium' | 'primaryLarge' | 'secondaryXSmall' | 'secondarySmall' | 'secondaryLarge' | 'outlineXSmall' | 'outlineSmall' | 'outlineMedium' | 'outlineLarge' | undefined
  title?: string
  content?: any
  product?: any
  discounts?: any
  labelAtc: string
  active: boolean
  amount: number,
  productId?: string,
  variantId?: string,
  subscriptionConfig?: any,
  upsell?: {
    parametersStep?: boolean,
    subscriptionConfig?: any,
    upsellingItems?: {
      parametersHeading?: string,
      parametersSubheading?: string,
      parameters?: {
        _id: string
        title: string
        description: string
        image: any
        productSlug?: string
        variantSlug?: string
        originalPrice: string
        discountedPrice: string
      }[],
      shippingMethodsHeading?: string
      shippingMethods?: {
        _id: string
        title: string
        type: string
        heading: string
        price: string
        description: string
        colorClass: string
        textColorClass: string
        features: {
          icon: string
          description: string
        }[]
      }[]
    }
    shippingStep: boolean,
    subscriptionStep: boolean,
    product?: any
  }
}

const AddToCartButton: React.FC<AddToCartButtonProps> = (({
                                                            styleVariant,
                                                            labelAtc,
                                                            product,
                                                            active,
                                                            amount,
                                                            productId,
                                                            variantId,
                                                            upsell,
                                                            discounts,
                                                            subscriptionConfig
                                                          }) => {
  const addLine = useAddLine()
  const { openModal, setModalView, setUpsellInfo } = useUI()
  const [loading, setLoading] = useState(false)
  const t = useTranslations('Product')
  const [selectedOptions, setSelectedOptions] = useState<SelectedOptions>({})
  const updateDiscount = useUpdateDiscount()
  const router = useRouter()
  const awc = Cookies.get('awc')
  const pid = Cookies.get('pid')
  const ref = Cookies.get('ref')

  useEffect(() => {
    if (product == null || isEmpty(product)) return
    selectDefaultOptionFromProduct(product, setSelectedOptions)
  }, [product])

  let variant: any
  if (productId == null && variantId == null) {
    variant = product != null && !isEmpty(product) ? getProductVariant(product, selectedOptions) : undefined
  }
  const addToCart = async (skipCartConflictCheck?: boolean) => {

    setLoading(true)
    try {
      const processedVariantId = String(variantId ?? (variant ? variant.id : product.variants[0].id))
      const processedQuantity = Number(amount || 1)

      let updatedCart
      if (ref) {
        updatedCart = await addLine({
          merchandiseId: processedVariantId,
          quantity: processedQuantity,
          attributes: [{ key: 'ref', value: ref }]
        })
      } else if (pid) {
        updatedCart = await addLine({
          merchandiseId: processedVariantId,
          quantity: processedQuantity,
          attributes: [{ key: 'pid', value: pid }]
        })
      } else if (awc) {
        updatedCart = await addLine({
          merchandiseId: processedVariantId,
          quantity: processedQuantity,
          attributes: [{ key: 'awc', value: awc }]
        })
      } else {
        updatedCart = await addLine({
          merchandiseId: processedVariantId,
          quantity: processedQuantity
        })
      }

      const discountCookie = Cookies.get('remiDiscountCode')
      if (discountCookie) {
        try {
          const discount = updateDiscount(discountCookie as string)
          if (discount) {
          }
        } catch (e) {
          console.error(e)
        }
      }


      const hasParametersStep = (upsell?.parametersStep ?? true) && (upsell?.upsellingItems?.parameters ?? []).length > 0
      const hasShippingStep = (upsell?.shippingStep ?? true) && (upsell?.upsellingItems?.shippingMethods ?? []).length > 0
      const hasSubscriptionStep = (upsell?.subscriptionStep ?? true) && (upsell?.subscriptionConfig?.plans ?? []).length > 0

      await new Promise((resolve, reject) => setTimeout(() => resolve(null), 500))

      if (updatedCart && (hasParametersStep || hasShippingStep || hasSubscriptionStep)) {
        // get line item that was added (LineItem.productId can contain variant id...)
        const lineItem = updatedCart?.lines?.find(
          (item: any) => (item.merchandise?.id === processedVariantId)
        )

        setTimeout(() => {
          // @ts-ignore
          if (!window.ElevarDataLayer.find(o => o.event === 'dl_add_to_cart')) {
            // @ts-ignore
            window.ElevarDataLayer?.push({
              event: 'dl_add_to_cart',
              user_properties: {
                user_consent: '',
                visitor_type: 'guest'
              },
              ecommerce: {
                currencyCode: 'EUR',
                add: {
                  actionField: {
                    list: location.pathname // this should be the collection page URL that user clicked product from
                  },
                  products: [
                    {
                      id: product?.id, // SKU
                      name: product?.name, // Product title
                      variant: product?.name,
                      category: '',
                      brand: 'Remi Health',
                      list: 'Product List',
                      price: (product?.variants[0]?.price)?.toString(),
                      product_id: product?.id, // The product_id
                      variant_id: product?.variants[0]?.id, // id or variant_id
                      compare_at_price: '0.0', // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
                      image: product?.images[0]?.url // If available, otherwise use an empty string
                    }
                  ]
                }
              }
            })
          }
        }, 500)

        setUpsellInfo({
          parametersStep: upsell?.parametersStep ?? true,
          shippingStep: upsell?.shippingStep ?? true,
          subscriptionStep: upsell?.subscriptionStep ?? true,
          upsellingItems: upsell?.upsellingItems,
          product: {
            ...(upsell?.product ?? {}),
            shopifyProduct: product
          },
          discounts,
          subscriptionConfig: upsell?.subscriptionConfig,
          lineItem: lineItem
        })
        setModalView('UPSELL_VIEW')
        openModal(undefined, true)
      } else {
        await router.replace('/cart')
      }

      setLoading(false)
    } catch (err) {
      console.error(err)
      setLoading(false)
    }
  }

  const label = (active ? (labelAtc) : t('outOfStock'))

  return (
    <Button className={s.button + ' w-full ' + (!active ? s.outOfStock : '')} disabled={!active}
            onClick={() => addToCart()} variant={styleVariant ?? 'secondaryMedium'}>{label}</Button>
  )
})

export default AddToCartButton
